import { render, staticRenderFns } from "./GeneralInventoryReport.vue?vue&type=template&id=bc179430&"
import script from "./GeneralInventoryReport.vue?vue&type=script&lang=js&"
export * from "./GeneralInventoryReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports